// Per-service consent for the tarteaucitron services registered in
// src/php/Consent.php (keys like "vsyoutube").

// Runs `cb` once the service is launched: right away if the visitor already
// accepted it, otherwise when they do (banner, preferences panel or grant()).
// tarteaucitron dispatches `<key>_loaded` on document each time it launches one.
export function whenConsented(key, cb) {
  if (window.tarteaucitron?.launch?.[key] === true) {
    cb();
    return;
  }
  document.addEventListener(`${key}_loaded`, cb, { once: true });
}

// Accepts this one service, the same as its "Allow" button in the preferences
// panel (whose id respond() derives the key from). That button only exists once
// tarteaucitron has built its panel, so this is a no-op before then.
export function grantConsent(key) {
  const allowBtn = document.getElementById(`${key}Allowed`);
  if (allowBtn) window.tarteaucitron.userInterface.respond(allowBtn, true);
}
